import { render, staticRenderFns } from "./buLu.vue?vue&type=template&id=11bb9584&scoped=true&"
import script from "./buLu.vue?vue&type=script&lang=js&"
export * from "./buLu.vue?vue&type=script&lang=js&"
import style0 from "./buLu.vue?vue&type=style&index=0&id=11bb9584&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "11bb9584",
  null
  
)

export default component.exports